module.exports = __webpack_public_path__ + "media/images/icons/search-where-what-40999b794fea560edb56bc6b7aaeebde.svg";